import React, { useState, useEffect } from "react";
import dayjs from "dayjs";
import { Box, Typography } from "@mui/material";

const Cards = ({
  width,
  data,
  title,
  onFilterChange,
  flexwrap,
  filterTitle,
  setSelectedMonth,
  setSelectedYear,
  selectedMonth,
  selectedYear,
}) => {
  const [selectedFilters, setSelectedFilters] = useState({});

  let initialData = async () => {
    const initialFilters = {};
    await data?.forEach((item) => {
      if (item?.filter === "option" && item?.defaultValue) {
        initialFilters[item?.key] = item?.defaultValue;
      }
      if (item.filter === "date") {
        const currentDate = dayjs().format("YYYY-MM");
        initialFilters[item.key] = currentDate;
      }
    });
    setSelectedFilters(initialFilters);

    if (onFilterChange) {
      Object.entries(initialFilters).forEach(([key, value]) => {
        const filterType = data.find((item) => item.key === key)?.filter;
        onFilterChange(key, value, filterType);
      });
    }
  };

  useEffect(() => {
    initialData();
  }, []);

  const handleSelect = (key, value, filterType) => {
    console.log(key, value, filterType, "value to selcet");
    setSelectedFilters((prev) => ({
      ...prev,
      [key]: value,
    }));
    if (onFilterChange) {
      console.log("handleSelect1");
      onFilterChange(key, value, filterType);
    }
  };

  return (
    <>
      <p
        style={{
          fontWeight: "700",
          fontSize: "22px",
          color: "#001632",
          fontFamily: "Inter",
          textDecoration: "underline",
          marginTop: "1rem",
          marginBottom: "1.5rem",
        }}
      >
        {title}
      </p>
      <Box
        sx={{
          display: "flex",
          flexWrap: flexwrap === "no" ? "" : "wrap",
          gap: "1rem",
          justifyContent: "space-between",
        }}
      >
        {data?.map((item, index) => (
          //   <FilterCard
          //     {...{
          //       setSelectedMonth,
          //       setSelectedYear,
          //       selectedMonth,
          //       selectedYear,
          //       width,
          //     }}
          //     key={idx}
          //     item={item}
          //     selectedValue={selectedFilters[item.key]}
          //     handleSelect={handleSelect}
          //   />
          <Box
            sx={{
              backgroundColor: "#FCFCFC",
              borderRadius: "12px",
              padding: "1.25rem",
              boxShadow: "rgba(0, 0, 0, 0.15)",
              width: "32%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              //   height: "10rem",
            }}
          >
            <Box
              sx={{
                display: "flex",
                gap: "0.3rem",
                //   flexDirection: "column",
                justifyContent: "space-between",
                marginBottom: "1rem",
              }}
            >
              <Typography
                sx={{
                  fontFamily: "Inter",
                  fontSize: "16px",
                  fontWeight: "600",
                  color: "#000000",
                }}
              >
                {item?.title}
              </Typography>
            </Box>
            {/* { item?.description?.length >0 && item?.description.map((values,index)=>{
            return <Box 
              sx={{
                display: "flex",
                gap: "0.3rem",
                //   flexDirection: "column",
                justifyContent: "space-between",
              }}
            > 
           <Box> {Object.keys(values)}</Box>
<Box>{values}</Box>
            </Box>
        })} */}
            {Array.isArray(item?.description) ? (
              item.description.map((values, index) => {
                return (
                  <Box
                    key={index}
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginBottom: "0.3rem",
                      color: "#333333",
                    }}
                  >
                    {/* Check if `values` is an object */}
                    {typeof values === "object" && values !== null ? (
                      <>
                        <Box>{Object.keys(values)[0]}</Box>
                        <Box>{Object.values(values)[0]}</Box>
                      </>
                    ) : (
                      <Box>{values}</Box>
                    )}
                  </Box>
                );
              })
            ) : (
              <Box>{item?.description}</Box> // Directly show string descriptions
            )}
          </Box>
        ))}
      </Box>
    </>
  );
};

export default Cards;
